import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";

@Component({
  selector: "app-cancelicon",
  templateUrl: "./cancelicon.component.html",
  styleUrls: ["./cancelicon.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CanceliconComponent implements OnInit {
  @Input() type: string;
  @Input() description: string;
  @Input() class: string;
  @Input() data: string;
  @Input() routerLink: any;
  @Input() title: string;
  @Output() callFunction = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onClick(event: any) {
    this.callFunction.emit(event);
  }
}
